/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  sequences: [],
  pagination: {},
  new_custom_sequence: {
    name: 'Your new Sequence',
    takt_time: {
      value: 5,
      unit: 'day',
      hashtag: 'TT5D'
    },
    country: {
      name: 'Select country',
      flag: ''
    },
    waggons: [
      {
        work_packages: []
      },
      {
        work_packages: []
      },
      {
        work_packages: []
      }
    ],
    hashtags: ['TT5D']
  }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getError: (state) => state.error,
  getSequences: (state) => state.sequences,
  getPagination: (state) => state.pagination,
  getSequencesFiltered: (state) => (search) => {
    if (search !== '') {
      return state.sequences.filter(sequence =>
        sequence.name.toLowerCase().includes(search.toLowerCase()) ||
        sequence.hashtags.filter(hashtag => {
          hashtag.tag.toLowerCase().includes(search.toLowerCase());
        }).length !== 0
      );
    } else {
      return state.sequences;
    }
  },
  getNewCustomSequence: (state) => state.new_custom_sequence,
  isLoading: (state) => state.loading
};
// Actions
const actions = {
  changeNewCustomSequenceWaggonLength({commit}, payload){
    if (payload.new_len > payload.curr_len) {
      commit('add_new_custom_sequence_waggons', payload.new_len);
    }
    if (payload.new_len < payload.curr_len) {
      commit('remove_new_custom_sequence_waggons', payload.new_len);
    }
  },
  createCompleteSequence({commit, getters}){
    // commit('set_loading', true);
    return new Promise((resolve, reject) => {
      let stateSequence = getters.getNewCustomSequence;
      let sequence = {};
      sequence.name = stateSequence.name;
      sequence.country = stateSequence.country.flag;
      sequence.takt_time_value = stateSequence.takt_time.value;
      sequence.takt_time_unit = stateSequence.takt_time.unit;
      sequence.waggons = [];
      for (let i = 0; i < stateSequence.waggons.length; i++) {
        let waggon = { work_packages: [] };
        for (let j = 0; j < stateSequence.waggons[i].work_packages.length; j++) {
          let work_package = {
            work_steps: [],
            quality_steps: [],
            defect_steps: [],
            handover_steps: [],
            design_steps: [],
            logistic_steps: [],
           };
          work_package.name = stateSequence.waggons[i].work_packages[j].name;
          work_package.token = stateSequence.waggons[i].work_packages[j].token;
          work_package.icon = stateSequence.waggons[i].work_packages[j].icon;
          work_package.description = stateSequence.waggons[i].work_packages[j].description;
          work_package.color = stateSequence.waggons[i].work_packages[j].color;
          work_package.textcolor = stateSequence.waggons[i].work_packages[j].textcolor;
          // work_package.workload = stateSequence.waggons[i].work_packages[j].workload;
          work_package.manpower_planned = stateSequence.waggons[i].work_packages[j].manpower_planned || 0;
          work_package.time_effort_planned = stateSequence.waggons[i].work_packages[j].time_effort_planned || 0;
          work_package.quantity_value = stateSequence.waggons[i].work_packages[j].quantity_value || 0;
          work_package.quantity_unit = stateSequence.waggons[i].work_packages[j].quantity_unit || '';
          work_package.contact_name = stateSequence.waggons[i].work_packages[j].contact_name || '';
          work_package.contact_phone_number = stateSequence.waggons[i].work_packages[j].contact_phone_number || '';
          work_package.contact_email = stateSequence.waggons[i].work_packages[j].contact_email || '';

          for (let k = 0; k < stateSequence.waggons[i].work_packages[j].work_steps.length; k++) {
            let work_step = {};
            work_step.text = stateSequence.waggons[i].work_packages[j].work_steps[k].text;
            work_step.manpower_planned = stateSequence.waggons[i].work_packages[j].work_steps[k].manpower_planned;
            work_package.work_steps.push(work_step);
          }
          for (let l = 0; l < stateSequence.waggons[i].work_packages[j].quality_steps.length; l++) {
            let quality_step = {};
            quality_step.text = stateSequence.waggons[i].work_packages[j].quality_steps[l].text;
            quality_step.offset = stateSequence.waggons[i].work_packages[j].quality_steps[l].offset;
            work_package.quality_steps.push(quality_step);
          }
          for (let m = 0; m < stateSequence.waggons[i].work_packages[j].defect_steps.length; m++) {
            let defect_step = {};
            defect_step.text = stateSequence.waggons[i].work_packages[j].defect_steps[m].text;
            defect_step.offset = stateSequence.waggons[i].work_packages[j].defect_steps[m].offset;
            work_package.defect_steps.push(defect_step);
          }
          for (let n = 0; n < stateSequence.waggons[i].work_packages[j].handover_steps.length; n++) {
            let handover_step = {};
            handover_step.text = stateSequence.waggons[i].work_packages[j].handover_steps[n].text;
            handover_step.offset = stateSequence.waggons[i].work_packages[j].handover_steps[n].offset;
            work_package.handover_steps.push(handover_step);
          }
          for (let o = 0; o < stateSequence.waggons[i].work_packages[j].design_steps.length; o++) {
            let design_step = {};
            design_step.text = stateSequence.waggons[i].work_packages[j].design_steps[o].text;
            design_step.offset = stateSequence.waggons[i].work_packages[j].design_steps[o].offset;
            work_package.design_steps.push(design_step);
          }
          for (let p = 0; p < stateSequence.waggons[i].work_packages[j].logistic_steps.length; p++) {
            let logistic_step = {};
            logistic_step.text = stateSequence.waggons[i].work_packages[j].logistic_steps[p].text;
            logistic_step.offset = stateSequence.waggons[i].work_packages[j].logistic_steps[p].offset;
            work_package.logistic_steps.push(logistic_step);
          }
          waggon.work_packages.push(work_package);
        }
        sequence.waggons.push(waggon);
      }

      axios({
        url: 'sequences',
        method: 'POST',
        data: sequence
      })
      .then(resp => {
        commit('add_sequence', resp.data.data);
        commit('reset_sequence_editor');
        // commit('set_loading', false);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        // commit('set_loading', false);
        reject();
      });
    });
  },
  requestCustomSequences({
    commit
  }, page) {
    return new Promise((resolve, reject) => {
      let offset = (page - 1 || 0) * 15;
      commit('set_loading', true);
      axios({
          url: 'sequences?show=showForSequence&offset=' + offset + '&limit=50',
          method: 'GET',
          headers: {'Cache-Control': 'no-cache'}
        })
        .then(resp => {
          commit('set_sequences', resp.data.data);
          commit('set_sequences_pagination', resp.data.meta_data);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          // commit('set_loading', false);
          reject();
        });
    });
  },
  deleteSequence({commit}, sequence_id){
    axios({
      url: 'sequences/' + sequence_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('delete_sequence', sequence_id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteSWaggon({commit}, payload){
    axios({
      url: 'sequences/' + payload.sequence_id + '/swaggons/' + payload.waggon_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('delete_swaggon', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  setSWorkPackages( {commit}, payload){
      commit('set_swork_packages', payload);
  },
  setNewCustomSequenceName( {commit}, payload){
    commit('set_new_custom_sequence_name', payload);
  },
  setNewCustomSequenceCountry( {commit}, payload){
    commit('set_new_custom_sequence_country', payload);
  },
  setNewCustomSequenceTaktTime( {commit}, payload){
    commit('set_new_custom_sequence_takt_time', payload);
  },
  setNewCustomSequenceHashtags( {commit}, payload){
    commit('set_new_custom_sequence_hashtags', payload);
  },
  suggestToCommunity({commit}, sequence_id){
    axios({
      url: 'sequences/' + sequence_id,
      method: 'PUT',
      data: {
        is_community_suggested: true
      }
    })
    .then(() => {
      commit('update_community_suggested', sequence_id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  pushSWaggonPosition({commit}, payload){
    axios({
      url: 'sequences/' + payload.sequence_id + '/swaggons/' + payload.waggon_id + '/pushpositions',
      method: 'PUT',
      data: {
        waggon: payload.other_waggon_id
      }
    })
    .then(() => {
      commit('swaggon_push_position', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  pushSWorkPackagePosition({commit}, payload){
    axios({
      url: 'sequences/' +
           payload.sequence_id +
           '/swaggons/' +
           payload.waggon_id +
           '/sworkpackages/' +
           payload.work_package_id +
           '/pushpositions',
      method: 'PUT',
      data: {
        work_package: payload.other_work_package_id
      }
    })
    .then(() => {
      commit('swork_package_push_position', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  changeSWorkPackageSWaggon({commit}, payload){
    axios({
      url: 'sequences/' +
           payload.sequence_id +
           '/swaggons/' +
           payload.waggon_id +
           '/sworkpackages/' +
           payload.work_package_id +
           '/changeswaggon',
      method: 'PUT',
      data: {
        waggon: payload.other_waggon_id,
        position: payload.new_index + 1
      }
    })
    .then(() => {
      commit('swork_package_change_swaggon', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateSequence({commit}, payload){
    axios({
      url: 'sequences/' + payload.sequence_id,
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_sequence', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createCompleteSWaggon({commit}, payload){
    axios({
      url: 'sequences/' + payload.sequence_id + '/swaggons/completeswaggon',
      method: 'POST',
      data: payload.waggon
    })
    .then(resp => {
      commit('add_waggon_to_sequence', {waggon: resp.data.data, payload: payload});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createCompleteSWorkPackage({commit}, payload){
    axios({
      url: 'sequences/' + payload.sequence_id + '/swaggons/' + payload.waggon_id + '/sworkpackages/completesworkpackage',
      method: 'POST',
      data: payload.work_package
    })
    .then(resp => {
      commit('add_work_package_to_sequence', {work_package: resp.data.data, payload: payload});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
};
// Mutations
const mutations = {
  add_new_custom_sequence_waggons(state, len){
    while (state.new_custom_sequence.waggons.length < len) {
      state.new_custom_sequence.waggons.push({
        work_packages: []
      });
    }
  },
  add_waggon_to_sequence(state, payload){
    const sequence_index = state.sequences.findIndex(function(item) {
      return item.id == payload.payload.sequence_id;
    });
    let sequence = state.sequences[sequence_index];
    let swaggon_index = payload.waggon.position - 1;
    sequence.waggons = [
      ...sequence.waggons.slice(0, swaggon_index),
      payload.waggon,
      ...sequence.waggons.slice(swaggon_index)
    ];
    state.sequences = [
      ...state.sequences.slice(0, sequence_index),
      sequence,
      ...state.sequences.slice(sequence_index + 1)
    ];
  },
  add_work_package_to_sequence(state, payload){
    const sequence_index = state.sequences.findIndex(function(item) {
      return item.id == payload.payload.sequence_id;
    });
    let sequence = state.sequences[sequence_index];
    const waggon_index = sequence.waggons.findIndex(function(item) {
      return item.id == payload.payload.waggon_id;
    });
    let waggon = state.sequences[sequence_index].waggons[waggon_index];
    let work_package_index = payload.work_package.position - 1;

    waggon.work_packages = [
      ...waggon.work_packages.slice(0, work_package_index),
      payload.work_package,
      ...waggon.work_packages.slice(work_package_index)
    ];

    sequence.waggons = [
      ...sequence.waggons.slice(0, waggon_index),
      waggon,
      ...sequence.waggons.slice(waggon_index + 1)
    ];
    state.sequences = [
      ...state.sequences.slice(0, sequence_index),
      sequence,
      ...state.sequences.slice(sequence_index + 1)
    ];
  },
  add_sequence(state, sequence) {
    state.sequences = [...state.sequences, sequence];
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  reset_sequence_editor(state){
    state.new_custom_sequence = {
      name: 'Your new Sequence',
      takt_time: {
        value: 5,
        unit: 'day'
      },
      country: {
        name: 'Select country',
        flag: ''
      },
      waggons: [
        {work_packages: []},
        {work_packages: []},
        {work_packages: []}
      ],
      hashtags: ['TT5D']
    };
  },
  remove_new_custom_sequence_waggons(state, len){
    while (state.new_custom_sequence.waggons.length > len) {
      state.new_custom_sequence.waggons.splice(-1, 1);
    }
  },
  set_swork_packages(state, payload){
    state.new_custom_sequence.waggons[payload.index].work_packages = [...payload.work_packages];
  },
  set_error(state, err) {
    state.error = err;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  set_sequences(state, sequences) {
    state.sequences = [...sequences];
  },
  set_sequences_pagination(state, meta_data) {
    state.pagination = meta_data;
  },
  set_new_custom_sequence_waggons(state, waggons) {
    state.new_custom_sequence.waggons = [...waggons];
  },
  set_new_custom_sequence_name(state, name){
    state.new_custom_sequence.name = name;
  },
  set_new_custom_sequence_country(state, country){
    state.new_custom_sequence.country = country;
  },
  set_new_custom_sequence_takt_time(state, takt_time){
    const curr_hashtag = state.new_custom_sequence.takt_time.hashtag;
    const index = state.new_custom_sequence.hashtags.indexOf(curr_hashtag);
    state.new_custom_sequence.hashtags.splice(index, 1, takt_time.hashtag);
    state.new_custom_sequence.takt_time = takt_time;
  },
  set_new_custom_sequence_hashtags(state, hashtags){
    state.new_custom_sequence.hashtags = [...hashtags];
  },
  update_community_suggested(state, sequence_id){
    const index = state.sequences.findIndex(function(item) {
      return item.id == sequence_id;
    });
    let sequence = state.sequences[index];
    sequence.is_community_suggested = true;
    state.sequences = [
      ...state.sequences.slice(0, index),
      sequence,
      ...state.sequences.slice(index + 1)
    ];
  },
  update_sequence(state, payload){
    const index = state.sequences.findIndex(function(item) {
      return item.id == payload.sequence_id;
    });
    let sequencec = state.sequences[index];
    state.sequences = [
      ...state.sequences.slice(0, index),
      Object.assign(sequencec, payload.update),
      ...state.sequences.slice(index + 1)
    ];
  },
  delete_sequence(state, sequence_id){
    const index = state.sequences.findIndex(function(item) {
      return item.id == sequence_id;
    });
    state.sequences = [
      ...state.sequences.slice(0, index),
      ...state.sequences.slice(index + 1)
    ];
  },
  delete_swaggon(state, payload){
    const index = state.sequences.findIndex(function(item) {
      return item.id == payload.sequence_id;
    });
    let sequence = state.sequences[index];
    const waggon_index = sequence.waggons.findIndex(function(item) {
      return item.id == payload.waggon_id;
    });
    sequence.waggons = [
      ...sequence.waggons.slice(0, waggon_index),
      ...sequence.waggons.slice(waggon_index + 1)
    ];
    state.sequences = [
      ...state.sequences.slice(0, index),
      sequence,
      ...state.sequences.slice(index + 1)
    ];
  },
  swaggon_push_position(state, payload){
    const index = state.sequences.findIndex(function(item) {
      return item.id == payload.sequence_id;
    });
    let sequence = state.sequences[index];
    let waggon = state.sequences[index].waggons[payload.old_index];

    if (payload.old_index < payload.new_index) {
      sequence.waggons = [
        ...sequence.waggons.slice(0, payload.old_index),
        ...sequence.waggons.slice(payload.old_index + 1, payload.new_index + 1),
        waggon,
        ...sequence.waggons.slice(payload.new_index + 1)
      ];
    } else {
      sequence.waggons = [
        ...sequence.waggons.slice(0, payload.new_index),
        waggon,
        ...sequence.waggons.slice(payload.new_index, payload.old_index),
        ...sequence.waggons.slice(payload.old_index + 1)
      ];
    }
    state.sequences = [
      ...state.sequences.slice(0, index),
      sequence,
      ...state.sequences.slice(index + 1)
    ];
  },
  swork_package_push_position(state, payload){
    const sequence_index = state.sequences.findIndex(function(item) {
      return item.id == payload.sequence_id;
    });
    let sequence = state.sequences[sequence_index];
    const waggon_index = sequence.waggons.findIndex(function(item) {
      return item.id == payload.waggon_id;
    });
    let waggon = state.sequences[sequence_index].waggons[waggon_index];
    let work_package = state.sequences[sequence_index].waggons[waggon_index].work_packages[payload.old_index];

    if (payload.old_index < payload.new_index) {
      waggon.work_packages = [
        ...waggon.work_packages.slice(0, payload.old_index),
        ...waggon.work_packages.slice(payload.old_index + 1, payload.new_index + 1),
        work_package,
        ...waggon.work_packages.slice(payload.new_index + 1)
      ];
    } else {
      waggon.work_packages = [
        ...waggon.work_packages.slice(0, payload.new_index),
        work_package,
        ...waggon.work_packages.slice(payload.new_index, payload.old_index),
        ...waggon.work_packages.slice(payload.old_index + 1)
      ];
    }

    sequence.waggons = [
      ...sequence.waggons.slice(0, waggon_index),
      waggon,
      ...sequence.waggons.slice(waggon_index + 1)
    ];
    state.sequences = [
      ...state.sequences.slice(0, sequence_index),
      sequence,
      ...state.sequences.slice(sequence_index + 1)
    ];
  },
  swork_package_change_swaggon(state, payload){
    const sequence_index = state.sequences.findIndex(function(item) {
      return item.id == payload.sequence_id;
    });
    let sequence = state.sequences[sequence_index];
    const waggon_index = sequence.waggons.findIndex(function(item) {
      return item.id == payload.waggon_id;
    });
    let old_waggon = state.sequences[sequence_index].waggons[waggon_index];
    let work_package = state.sequences[sequence_index].waggons[waggon_index].work_packages[payload.old_index];

    old_waggon.work_packages = [
      ...old_waggon.work_packages.slice(0, payload.old_index),
      ...old_waggon.work_packages.slice(payload.old_index + 1),
    ];

    const other_waggon_index = sequence.waggons.findIndex(function(item) {
      return item.id == payload.other_waggon_id;
    });
    let new_waggon = state.sequences[sequence_index].waggons[other_waggon_index];

    new_waggon.work_packages = [
      ...new_waggon.work_packages.slice(0, payload.new_index),
      work_package,
      ...new_waggon.work_packages.slice(payload.new_index)
    ];

    if (waggon_index < other_waggon_index) {
      sequence.waggons = [
        ...sequence.waggons.slice(0, waggon_index),
        old_waggon,
        ...sequence.waggons.slice(waggon_index + 1, other_waggon_index),
        new_waggon,
        ...sequence.waggons.slice(other_waggon_index + 1)
      ];
    } else {
      sequence.waggons = [
        ...sequence.waggons.slice(0, other_waggon_index),
        new_waggon,
        ...sequence.waggons.slice(other_waggon_index + 1, waggon_index),
        old_waggon,
        ...sequence.waggons.slice(waggon_index + 1)
      ];
    }
    state.sequences = [
      ...state.sequences.slice(0, sequence_index),
      sequence,
      ...state.sequences.slice(sequence_index + 1)
    ];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
